"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-pencil-16><path d="M15.086.914a3.127 3.127 0 0 0-4.414 0l-9.379 9.379a1.001 1.001 0 0 0-.263.465l-1 4a1 1 0 0 0 1.212 1.212l4-1c.176-.044.337-.135.465-.263l9.379-9.379a3.125 3.125 0 0 0 0-4.414Zm-1.415 1.414c.437.438.438 1.147.001 1.586L13 4.586 11.414 3l.672-.672a1.121 1.121 0 0 1 1.585 0ZM4.488 13.097l-2.114.529.53-2.114L10 4.414 11.586 6l-7.098 7.097Z"></path></symbol>';
}
